(function() {
    'use strict';

    angular
        .module('completeAir')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$cookies', 'CONFIG'];

    function AuthServerProvider ($http, $localStorage, $cookies, CONFIG) {

        var urlBaseOauth = CONFIG.API_URL + '/uaa';

        var service = {
            setAccessToken: setAccessToken,
            getToken: getToken,
            setIsBranch: setIsBranch,
            getIsBranch: getIsBranch,
            setExpiresIn: setExpiresIn,
            getExpiresIn: getExpiresIn,
            setUserAccount: setUserAccount,
            getUserAccount: getUserAccount,
            setUserBranch: setUserBranch,
            getUserBranch: getUserBranch,
            setUserSession: setUserSession,
            getUserSession: getUserSession,
            hasValidToken: hasValidToken,
            login: login,
            refreshToken: refreshToken,
            logout: logout
        };

        return service;

        function setAccessToken(data) {
            var expireDate = new Date (new Date().getTime() + (1000 * data.expires_in));
            $cookies.put("access_token", data.access_token, {'expires': expireDate});
            $cookies.put("refresh", data.refresh_token, {'expires': expireDate});
            $cookies.put("expires_in", expireDate);
            $cookies.put('user_account', null);
            $cookies.put('is_branch', false);
        }

        function getToken () {
            /*var token = $localStorage.authenticationToken;
            return token;*/
            return null;
        }

        function setExpiresIn(isBranch) {
            $cookies.put("expires_in", isBranch);
        }

        function getExpiresIn() {
            return $cookies.get('expires_in');
        }

        function setIsBranch(isBranch) {
            $cookies.put("is_branch", isBranch);
        }

        function getIsBranch() {
            return $cookies.get('is_branch');

        }

        function setUserAccount(userAccount) {
            $cookies.put('user_account', btoa(JSON.stringify(userAccount)));
        }

        function getUserAccount() {
            return JSON.parse(atob($cookies.get('user_account')));
        }

        function setUserBranch(userBranch) {
            $cookies.put('user_branch', btoa(JSON.stringify(userBranch)));
        }

        function getUserBranch() {
            return JSON.parse(atob($cookies.get('user_branch')));
        }

        function setUserSession(userBranch) {
            $cookies.put('user_session', btoa(JSON.stringify(userBranch)));
        }

        function getUserSession() {
            return JSON.parse(atob($cookies.get('user_session')));
        }

        function hasValidToken () {
            var token = this.getToken();
            return !!token;
        }

        function login (data, visit) {
            var strEmail = visit ? '' : data.username + '@' + CONFIG.DOMAIN_ID;
            var clientId = visit ? CONFIG.CLIENT_ID_AIR : CONFIG.CLIENT_ID;
            var grantType = visit ? CONFIG.GRANT_TYPE_AIR : CONFIG.GRANT_TYPE;
            var secret = visit ? CONFIG.SECRET_AIR : CONFIG.SECRET;
            var urlLogin = visit ? urlBaseOauth + '/client' : urlBaseOauth + '/login';

            var loginData = {
                grant_type: grantType,
                username: strEmail,
                password: data.password,
                client_id: clientId
            };
            loginData = queryString.stringify(loginData);

            var encoded = btoa(clientId + ':' + secret);

            var options = angular.extend({
                headers: {
                    Authorization: "Basic " + encoded,
                    "Content-Type": "application/x-www-form-urlencoded",
                    AuthorizationBasic: encoded
                }
            }, options);

            return $http.post(urlLogin, loginData, options).then(function (response) {
                return response;
            });
        }

        function refreshToken (data) {
            data = angular.extend({
                client_id: "client",
                grant_type: "password",
                client_secret: 'secret',
                refresh_token: $cookies.remove("refresh")
            }, data);
            data = queryString.stringify(data);


            var options = angular.extend({
                headers: {
                    refresh_token_send: 'refresh_token_send'
                }
            }, options);

            return $http.post('' + urlBaseOauth + '/login', data, options).then(function (response) {
                return response;
            });
        }

        function removeAccessToken() {
            $cookies.remove('access_token');
            $cookies.remove('refresh');
            $cookies.remove('user_account');
            $cookies.remove('user_data');
            $cookies.remove('expires_in');
            $cookies.remove('user_session');
            $cookies.remove('user_branch');
            $cookies.remove('is_branch');

            delete $http.defaults.headers.common["Authorization"];
            delete $http.defaults.headers.common["access"];
            delete $http.defaults.headers.common["refresh"];
        }

        function logout () {
            // logout from the server
            $http.post(urlBaseOauth + "/logout").then(function (response) {
                removeAccessToken();
                return response;
            }).catch(function (error) {
                removeAccessToken();
            });

        }
    }
})();
